export interface AlternativeCardItem {
  id: number;
  competitor: string;
  title: string;
  description: string;
  href: string;
  accent: string;
}

export const ALTERNATIVE_CARDS: AlternativeCardItem[] = [
  {
    id: 0,
    competitor: "Oxylabs",
    title: "Proxidize vs Oxylabs",
    description:
      "Mobile and residential proxy pricing, country coverage, rotation, sessions, and migration — compared honestly.",
    href: "/alternatives/oxylabs",
    accent: "#5b8cff",
  },
  {
    id: 1,
    competitor: "Bright Data",
    title: "Bright Data Alternative for Mobile Proxies",
    description:
      "Bright Data's public pages list no mobile category. A comparison for buyers who need premium pooled mobile IPs.",
    href: "/alternatives/brightdata",
    accent: "#22d3ee",
  },
  {
    id: 2,
    competitor: "Decodo",
    title: "Proxidize vs Decodo",
    description:
      "Mobile and residential pricing against Decodo (formerly Smartproxy) — country coverage, and migration.",
    href: "/alternatives/decodo",
    accent: "#60A5FA",
  },
  {
    id: 3,
    competitor: "IPRoyal",
    title: "Proxidize vs IPRoyal",
    description:
      "Mobile and residential pricing against IPRoyal's broader proxy platform — dedicated vs rotating mobile plans, and migration.",
    href: "/alternatives/iproyal",
    accent: "#F472B6",
  },
  {
    id: 4,
    competitor: "SOAX",
    title: "Proxidize vs SOAX",
    description:
      "SOAX Alternative for mobile and residential proxies — global coverage vs simple flat-rate pricing, protocols, sticky sessions, and migration.",
    href: "/alternatives/soax",
    accent: "#818CF8",
  },
  {
    id: 5,
    competitor: "NodeMaven",
    title: "Proxidize vs NodeMaven",
    description:
      "NodeMaven Alternative for mobile and residential proxies — pooled pricing and IP quality filtering vs flat-rate pricing, targeting, and migration.",
    href: "/alternatives/nodemaven",
    accent: "#FB923C",
  },
  {
    id: 6,
    competitor: "Webshare",
    title: "Webshare Alternative for Mobile & Residential Proxies",
    description:
      "Webshare's public lineup has no mobile proxies. A comparison for buyers who need premium pooled mobile IPs or lower-cost residential bandwidth, against Webshare's free datacenter tier and static ISP proxies.",
    href: "/alternatives/webshare",
    accent: "#34D399",
  },
  {
    id: 7,
    competitor: "DataImpulse",
    title: "DataImpulse Alternative: Proxidize vs DataImpulse",
    description:
      "Matching $2/GB mobile and $1/GB residential headline rates — compared on volume pricing, targeting fees, sticky sessions, and KYC.",
    href: "/alternatives/dataimpulse",
    accent: "#38BDF8",
  },
];
